import {
	server_config,
	ico_he,
	picture_convert,
	behavior_config,
	wi,
	he,
	inwincount,
	reels_lenghts, reels_pos
} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_anim_add} from "../framework/src/engine/madnes/madnes_anims";
import {
	madnes_add_group,
	madnes_add_img,
	madnes_add_sprite,
	madnes_add_to_group,
	madnes_set_alpha,
	madnes_set_img_center,
	madnes_set_pos,
	madnes_set_pos_x,
	madnes_set_pos_y,
	madnes_set_visible,
	madnes_sprite_set_frame
} from "../framework/src/engine/madnes/madnes_object";
import {
	madnes_audio_allow_multiple,
	madnes_audio_is_playing,
	madnes_audio_loop,
	madnes_audio_play
} from "../framework/src/engine/madnes/madnes_audio";

import {madnes_add_bitmap_text, madnes_add_text, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {cylinder_pos} from "./j81_config";
import {stopposin, stopposin_old} from "./j81_core";
import {detect_joker} from "./j81_core_res_ctrl";

// Vytvoreni potrebnych onjektu z nactenych textur.
export function j81_print_desk()
{
	if(typeof behavior_config.reel.spin.motionBlur == "undefined")
	{
		behavior_config.reel.spin.motionBlur = 1;
	}

	if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
		if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
		{
			behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
		}
	}

	if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
		if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
		{
			behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
		}
	}

	if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
	{
		behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
	}

	if(typeof behavior_config.reel.brake.moveTime != "undefined")
	{
		behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
	}

	if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
	}

	if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
	}

	if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
	}

	if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
	}

	// madnes_set_win_factors(
	// 	behavior_config.reel.minBigWinFactor,
	// 	behavior_config.reel.minMegaWinFactor,
	// 	behavior_config.reel.minSuperMegaWinFactor
	// );

//	if(
//		typeof server_config.logic != "undefined" &&
//		typeof server_config.logic.bet_set != "undefined"
//	)
//	{
//		/*console.log(server_config.logic.bet_set);
//		madnes_init_bets(server_config.logic.bet_set);
//		console.log(bets);*/
//	}

	// bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

	madnes_add_img("background", "background", 0, 0);

	// Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
	for(var i = 0; i < cylinder_pos.length; i++) {

		for(var j in server_config.logic.reels[i]) {
			madnes_add_img("reels_bufer_"+i+"_"+j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999);
			madnes_set_img_center("reels_bufer_"+i+"_"+j, 0.5, 0.5);
			//madnes_sprite_set_frame("reels_bufer_"+i+"_"+j, 1);

			reels_lenghts[i] = j * 1 + 1;
			stopposin[i] = reels_lenghts[i];
			stopposin_old[i] = reels_lenghts[i];
		}

		// S0-S2 = priprava vyherni pozice na kazdem valci
		madnes_add_sprite("reels_bufer_" + i + "_S0", picture_convert[server_config.matrix.reelMatrix[i][2]], cylinder_pos[i], -9999);
		madnes_sprite_set_frame("reels_bufer_" + i + "_S0", 1);
		madnes_set_img_center("reels_bufer_" + i + "_S0", 0.5, 0.5);


		madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.matrix.reelMatrix[i][1]], cylinder_pos[i], -9999);
		madnes_sprite_set_frame("reels_bufer_" + i + "_S1", 1);
		madnes_set_img_center("reels_bufer_" + i + "_S1", 0.5, 0.5);

		madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.matrix.reelMatrix[i][0]], cylinder_pos[i], -9999);
		madnes_sprite_set_frame("reels_bufer_" + i + "_S2", 1);
		madnes_set_img_center("reels_bufer_" + i + "_S2", 0.5, 0.5);

		reels_pos[i] = 0;
	}

	madnes_add_img("cover", "reels_cover", 0, 0);

	for(var i = 0; i < cylinder_pos.length; i++) {

		for(var j = 0; j <= 2; j++) {

			madnes_add_img("win_frame_" + i + "_" + j, "winframe", -9999, -9999, 1, 0.5, 0.5);
			madnes_set_visible("win_frame_" + i + "_" + j, false);

			madnes_add_sprite("reels_bufer_" + i + "_TMP" + j, "", cylinder_pos[i], -9999, 1, 0.5, 0.5);
		}
	}

	var winline7_x = 132;
	madnes_add_img("winline7_0", "winline7_0", winline7_x, 200);
	madnes_add_img("winline7_1", "winline7_1", winline7_x, 210);

	madnes_add_img("winline7_3", "winline7_3", winline7_x, 375);
	madnes_add_img("winline7_4", "winline7_4", winline7_x, 210);
	madnes_add_img("winline7_2", "winline7_2", winline7_x, 205);

	madnes_add_img("winline7_6", "winline7_6", winline7_x, 550);
	madnes_add_img("winline7_5", "winline7_5", winline7_x, 205);

	for(var i = 0; i <= 6; i++) {
		madnes_set_visible("winline7_" + i, false);
	}

	for(var i = 1; i <= 81; i++) {
		madnes_add_img("winline81_" + i, "winline81_" + i, 128, 196);
		madnes_set_visible("winline81_" + i, false);
	}

	madnes_add_img("winlines7", "winlines7", winline7_x, 200);
	madnes_set_visible("winlines7", false);

	madnes_add_img("winlines81", "winlines81", 128, 196);
	madnes_set_visible("winlines81", false);

	//hide_all_lines();

	madnes_add_img("arrow_0_2", "arrow_left", 122, 198);
	madnes_set_img_center("arrow_0_2", 0.5, 0.5);

	madnes_add_img("arrow_0_1", "arrow_left", 122, 374);
	madnes_set_img_center("arrow_0_1", 0.5, 0.5);

	madnes_add_img("arrow_0_0", "arrow_left", 122, 549);
	madnes_set_img_center("arrow_0_0", 0.5, 0.5);

	madnes_add_img("arrow_1_2", "arrow_right", 1073, 198);
	madnes_set_img_center("arrow_1_2", 0.5, 0.5);

	madnes_add_img("arrow_1_1", "arrow_right", 1073, 374);
	madnes_set_img_center("arrow_1_1", 0.5, 0.5);

	madnes_add_img("arrow_1_0", "arrow_right", 1073, 549);
	madnes_set_img_center("arrow_1_0", 0.5, 0.5);


	madnes_add_img("arrow_7_0_2", "arrow_7_left", 122, 198);
	madnes_set_img_center("arrow_7_0_2", 0.5, 0.5);

	madnes_add_img("arrow_7_0_1", "arrow_7_left", 122, 374);
	madnes_set_img_center("arrow_7_0_1", 0.5, 0.5);

	madnes_add_img("arrow_7_0_0", "arrow_7_left", 122, 549);
	madnes_set_img_center("arrow_7_0_0", 0.5, 0.5);

	madnes_add_img("arrow_7_1_2", "arrow_7_right", 1073, 198);
	madnes_set_img_center("arrow_7_1_2", 0.5, 0.5);

	madnes_add_img("arrow_7_1_1", "arrow_7_right", 1073, 374);
	madnes_set_img_center("arrow_7_1_1", 0.5, 0.5);

	madnes_add_img("arrow_7_1_0", "arrow_7_right", 1073, 549);
	madnes_set_img_center("arrow_7_1_0", 0.5, 0.5);


	madnes_add_img("arrow_81_0_2", "arrow_81_left", 122, 198);
	madnes_set_img_center("arrow_81_0_2", 0.5, 0.5);

	madnes_add_img("arrow_81_0_1", "arrow_81_left", 122, 374);
	madnes_set_img_center("arrow_81_0_1", 0.5, 0.5);

	madnes_add_img("arrow_81_0_0", "arrow_81_left", 122, 549);
	madnes_set_img_center("arrow_81_0_0", 0.5, 0.5);

	madnes_add_img("arrow_81_1_2", "arrow_81_right", 1073, 198);
	madnes_set_img_center("arrow_81_1_2", 0.5, 0.5);

	madnes_add_img("arrow_81_1_1", "arrow_81_right", 1073, 374);
	madnes_set_img_center("arrow_81_1_1", 0.5, 0.5);

	madnes_add_img("arrow_81_1_0", "arrow_81_right", 1073, 549);
	madnes_set_img_center("arrow_81_1_0", 0.5, 0.5);

	hide_arrows();
	if(detect_joker([server_config.matrix.reelMatrix])) {
		arrow_show_81(false);
	} else {
		arrow_show_7();
	}

	var shiftBigWinX = -40;
	var shiftBigWinY = 0;

	madnes_add_group("bigwin_group");
	madnes_set_pos("bigwin_group", wi / 2 + shiftBigWinX, he / 2 + shiftBigWinY);

	madnes_add_img('bigwin_bg', 'bigwin_bg', 0, 0, 1, 0.5, 0.5);

	madnes_add_img('bigwin_label', 'bigwin_label', 0, -80, 1, 0.5, 0.5);
	madnes_add_img('megawin_label', 'megawin_label', 0, -80, 1, 0.5, 0.5);
	madnes_add_img('supermegawin_label', 'supermegawin_label', 0, -50, 1, 0.5, 0.5);

	madnes_add_bitmap_text("bigwin_text", "font_bigwin", 0, 70, "", 80);
	madnes_set_img_center("bigwin_text", 0.5, 0.5);

	madnes_add_to_group("bigwin_group", "bigwin_bg");
	madnes_add_to_group("bigwin_group", "bigwin_label");
	madnes_add_to_group("bigwin_group", "megawin_label");
	madnes_add_to_group("bigwin_group", "supermegawin_label");
	madnes_add_to_group("bigwin_group", "bigwin_text");

	madnes_set_visible("bigwin_group", false);
	hide_all_bigwin_texts();


	madnes_audio_allow_multiple("REEL_STOP_1");

	// madnes_recount_bet();
}

export function set_bigwin_type(type) {
	hide_all_bigwin_texts();

	if(type == "supermegawin") {
		madnes_set_pos_y("bigwin_text", 70);
	} else {
		madnes_set_pos_y("bigwin_text", 40);
	}

	madnes_set_visible(type + '_label', true);
}

function hide_all_bigwin_texts() {
	madnes_set_visible('bigwin_label', false);
	madnes_set_visible('megawin_label', false);
	madnes_set_visible('supermegawin_label', false);
}

export function clear_winframes() {
	for(var i in cylinder_pos) {

		for(var j = 0; j <= 2; j++) {
			madnes_set_pos("win_frame_" + i + "_" + j, -9999, -9999);
			madnes_set_visible("win_frame_" + i + "_" + j, false);
		}
	}
}

export function arrow_show_81(playSound) {
	if(playSound) {
		madnes_audio_play("joker_bell");
	}

	arrow_show_arrows("81", true);
	arrow_show_arrows("0", false);
}

export function arrow_show_7() {
	arrow_show_arrows('7', true);
	arrow_show_arrows("0", false);
}


function arrow_show_arrows(type, show) {
	if (typeof show === 'undefined') {
		show = true;
	}

	if (type === "0") {
		for (let c = 0; c <= 1; c++) {
			for (let r = 0; r <= 2; r++) {
				madnes_set_visible("arrow_" + c + "_" + r, show);
			}
		}
	} else {
		for (let c = 0; c <= 1; c++) {
			for (let r = 0; r <= 2; r++) {
				madnes_set_visible("arrow_" + type + "_" + c + "_" + r, show);
			}

		}
	}
}

export function hide_arrows() {
	arrow_show_arrows('81', false);
	arrow_show_arrows('7', false);
	arrow_show_arrows("0", true);
}
